import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './globals.css'

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://09638c985bdb5f302295451284b25fcb@o4509957842534400.ingest.us.sentry.io/4510909915529216",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: false,
  beforeSend(event) {
    if (window.location.hostname.indexOf('.local') !== -1) {
      return null; // Drops the event
    }
    return event;
  },
});


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)